import Table from './TableUserPending';
export default Table;